import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BellIcon, ContactIcon} from "@pg-design/icons-module";

import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlow} from "../../auth/state/registration_flow_slice";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {addFailureNotification} from "../../notifications/utils/add_failure_notification";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {useSubscribeToNewsletter} from "../hooks/useSubscribeToNewsletter";
import {openNewsletterSubscriptionModal} from "../slice/newsletter_subscription_modal_slice";
import {NotificationVariant} from "../types/NotificationVariant";

interface Props {
    customButton?: ({onClick}: {onClick: () => void}) => React.ReactNode;
    variant?: NotificationVariant;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const NewsletterFlowWithRegistrationTrigger = (props: Props) => {
    const {customButton, variant, amplitudePlacement} = props;
    const dispatch = useAppDispatch();
    const {hasCompleteProfile, hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();
    const {data: userProfile} = useGetUserProfileQuery();
    const {subscribeToNotifications} = useSubscribeToNewsletter();

    const openModal = async () => {
        if (!isUserLoggedIn || !hasPhoneVerified) {
            dispatch(
                startRegistrationFlow({
                    isUserLoggedIn,
                    hasCompleteProfile,
                    hasPhoneVerified,
                    userSource: UserSource.NEWSLETTER,
                    gtmSourceSection: GTMEventApplicationSourceSection.NEWSLETTER,
                    titleVariant: AuthModalVariant.NOTIFICATION_SUBSCRIPTION,
                    amplitudePlacement
                })
            );
            return;
        }
        if (userProfile) {
            await subscribeToNotifications(userProfile, true, false).catch(() => {
                dispatch(addFailureNotification("Nie udało się zapisać na powiadomienia. Spróbuj ponownie później."));
                return;
            });
        }
        dispatch(openNewsletterSubscriptionModal());
    };

    if (customButton) {
        return customButton({onClick: openModal});
    }

    switch (variant) {
        case NotificationVariant.MOBILE:
            return <BellIcon size="1.8" onClick={openModal} />;
        case NotificationVariant.ICON:
            return <BellIcon size="2.4" wrapperSize="4.8" wrapperColor="var(--colors-primary)" onClick={openModal} className={notificationsIcon} />;
        case NotificationVariant.BUTTON:
        default: {
            return (
                <Button size="small" variant="filled_primary" iconLeft={ContactIcon} onClick={openModal} className={notificationsButton}>
                    Włącz powiadomienia
                </Button>
            );
        }
    }
};

const notificationsButton = css({
    mb: 3,
    width: "100%",

    md: {
        mb: 0,
        maxWidth: "375px"
    }
});

const notificationsIcon = css({
    cursor: "pointer",

    "&:hover": {
        filter: "saturate(0.75)",
        boxShadow: "1"
    }
});
import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BellIcon, ContactIcon} from "@pg-design/icons-module";

import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlow} from "../../auth/state/registration_flow_slice";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {addFailureNotification} from "../../notifications/utils/add_failure_notification";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {useSubscribeToNewsletter} from "../hooks/useSubscribeToNewsletter";
import {openNewsletterSubscriptionModal} from "../slice/newsletter_subscription_modal_slice";
import {NotificationVariant} from "../types/NotificationVariant";

interface Props {
    customButton?: ({onClick}: {onClick: () => void}) => React.ReactNode;
    variant?: NotificationVariant;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const NewsletterFlowWithRegistrationTrigger = (props: Props) => {
    const {customButton, variant, amplitudePlacement} = props;
    const dispatch = useAppDispatch();
    const {hasCompleteProfile, hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();
    const {data: userProfile} = useGetUserProfileQuery();
    const {subscribeToNotifications} = useSubscribeToNewsletter();

    const openModal = async () => {
        if (!isUserLoggedIn || !hasPhoneVerified) {
            dispatch(
                startRegistrationFlow({
                    isUserLoggedIn,
                    hasCompleteProfile,
                    hasPhoneVerified,
                    userSource: UserSource.NEWSLETTER,
                    gtmSourceSection: GTMEventApplicationSourceSection.NEWSLETTER,
                    titleVariant: AuthModalVariant.NOTIFICATION_SUBSCRIPTION,
                    amplitudePlacement
                })
            );
            return;
        }
        if (userProfile) {
            await subscribeToNotifications(userProfile, true, false).catch(() => {
                dispatch(addFailureNotification("Nie udało się zapisać na powiadomienia. Spróbuj ponownie później."));
                return;
            });
        }
        dispatch(openNewsletterSubscriptionModal());
    };

    if (customButton) {
        return customButton({onClick: openModal});
    }

    switch (variant) {
        case NotificationVariant.MOBILE:
            return <BellIcon size="1.8" onClick={openModal} />;
        case NotificationVariant.ICON:
            return <BellIcon size="2.4" wrapperSize="4.8" wrapperColor="var(--colors-primary)" onClick={openModal} className={notificationsIcon} />;
        case NotificationVariant.BUTTON:
        default: {
            return (
                <Button size="small" variant="filled_primary" iconLeft={ContactIcon} onClick={openModal} className={notificationsButton}>
                    Włącz powiadomienia
                </Button>
            );
        }
    }
};

const notificationsButton = css({
    mb: 3,
    width: "100%",

    md: {
        mb: 0,
        maxWidth: "375px"
    }
});

const notificationsIcon = css({
    cursor: "pointer",

    "&:hover": {
        filter: "saturate(0.75)",
        boxShadow: "1"
    }
});
